export default {"src":"/_next/static/media/default-avatar.3f329f79.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};